import React from 'react';
import {
  EffectDateType,
  EffectDateTypeText,
  AnchorLayerType,
  AnchorLayerText,
  EffectState,
  EffectStateText,
  PositionSelectType,
  EffectVehicleType,
  EffectVehicleTypeText,
  EffectTimeType,
  EffectTimeTypeText,
  AttributeType,
  AttributeTypeText,
  LayerIdEnum,
  CLSTAG,
  EffectiveMapType,
  EffectiveMapTypeText,
} from '@/utils/constant';
import { clstagStr } from '.';
import type { FormConfig } from '@/components/CommonForm/formConfig';

export const effectTimeTypeOptions = [
  {
    label: EffectTimeTypeText.get(EffectTimeType.ALL_TIME),
    value: EffectTimeType.ALL_TIME,
  },
  {
    label: EffectTimeTypeText.get(EffectTimeType.PERIOD_TIME),
    value: EffectTimeType.PERIOD_TIME,
  },
];

export const typeOptions = [
  {
    label: AnchorLayerText.get(AnchorLayerType.MOVE_ROUND),
    value: AnchorLayerType.MOVE_ROUND,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.ROAD_CLOSED),
    value: AnchorLayerType.ROAD_CLOSED,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.NO_PARKING),
    value: AnchorLayerType.NO_PARKING,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.FOCUS_AREAS),
    value: AnchorLayerType.FOCUS_AREAS,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.ATTRIBUTE_ANNOTATION),
    value: AnchorLayerType.ATTRIBUTE_ANNOTATION,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.SPEED_LIMIT),
    value: AnchorLayerType.SPEED_LIMIT,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.AIR_GROUND_GEOFENCE),
    value: AnchorLayerType.AIR_GROUND_GEOFENCE,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.ROAD_TEST_FOCUS_AREA),
    value: AnchorLayerType.ROAD_TEST_FOCUS_AREA,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.LD_ASSIST),
    value: AnchorLayerType.LD_ASSIST,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.NAVIGATION),
    value: AnchorLayerType.NAVIGATION,
  },
  {
    label: AnchorLayerText.get(AnchorLayerType.NO_HORN_ZONE),
    value: AnchorLayerType.NO_HORN_ZONE,
  },
];
export const subTypeOptions = [
  {
    label: AttributeTypeText.get(AttributeType.HANGING_BRANCH),
    value: AttributeType.HANGING_BRANCH,
    imgUrl: require('@/assets/image/mapEditor/map_branches.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.BUMPY_ROAD),
    value: AttributeType.BUMPY_ROAD,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.DRAIN_COVER),
    value: AttributeType.DRAIN_COVER,
    imgUrl: require('@/assets/image/mapEditor/map_manhole_covers.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.UPWARD_SLOPE),
    value: AttributeType.UPWARD_SLOPE,
    imgUrl: require('@/assets/image/mapEditor/map_uphill.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.DOWNWARD_SLOPE),
    value: AttributeType.DOWNWARD_SLOPE,
    imgUrl: require('@/assets/image/mapEditor/map_downhill.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.INVALID_GATE),
    value: AttributeType.INVALID_GATE,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.BARRIER_GATE),
    value: AttributeType.BARRIER_GATE,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.UNMANNED_STATION),
    value: AttributeType.UNMANNED_STATION,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.INVALID_TRAFFIC_LIGHT),
    value: AttributeType.INVALID_TRAFFIC_LIGHT,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.FENCE),
    value: AttributeType.FENCE,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.STOP_FLAG),
    value: AttributeType.STOP_FLAG,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.PARK),
    value: AttributeType.PARK,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.BACKUP1),
    value: AttributeType.BACKUP1,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.BACKUP2),
    value: AttributeType.BACKUP2,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.INTERSECTION_LIGHT),
    value: AttributeType.INTERSECTION_LIGHT,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.INTERSECTION_PASS),
    value: AttributeType.INTERSECTION_PASS,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
  {
    label: AttributeTypeText.get(AttributeType.INTERSECTION_TAKEOVER),
    value: AttributeType.INTERSECTION_TAKEOVER,
    imgUrl: require('@/assets/image/mapEditor/map_jolt.png'),
  },
];

export const effectDateOptions = [
  {
    label: EffectDateTypeText.get(EffectDateType.PERMANENT),
    value: EffectDateType.PERMANENT,
  },
  {
    label: EffectDateTypeText.get(EffectDateType.SEASONAL),
    value: EffectDateType.SEASONAL,
  },
];
export const weekLimitOptions = [
  {
    label: '周一',
    value: 'MONDAY',
  },
  {
    label: '周二',
    value: 'TUESDAY',
  },
  {
    label: '周三',
    value: 'WEDNESDAY',
  },
  {
    label: '周四',
    value: 'THURSDAY',
  },
  {
    label: '周五',
    value: 'FRIDAY',
  },
  {
    label: '周六',
    value: 'SATURDAY',
  },
  {
    label: '周日',
    value: 'SUNDAY',
  },
];

export const EffectVehicleTypeOptions = [
  {
    label: (
      <div clstag={clstagStr(CLSTAG[EffectVehicleType.ALL_EFFECT])}>
        {EffectVehicleTypeText.get(EffectVehicleType.ALL_EFFECT)}
      </div>
    ),
    value: EffectVehicleType.ALL_EFFECT,
  },
  {
    label: (
      <div clstag={clstagStr(CLSTAG[EffectVehicleType.PART_EFFECT])}>
        {EffectVehicleTypeText.get(EffectVehicleType.PART_EFFECT)}
      </div>
    ),
    value: EffectVehicleType.PART_EFFECT,
  },
  {
    label: (
      <div clstag={clstagStr(CLSTAG[EffectVehicleType.PART_UN_EFFECT])}>
        {EffectVehicleTypeText.get(EffectVehicleType.PART_UN_EFFECT)}
      </div>
    ),
    value: EffectVehicleType.PART_UN_EFFECT,
  },
];
export const effectVehicleTypeList = [
  {
    label: EffectVehicleTypeText.get(EffectVehicleType.ALL_EFFECT),
    value: EffectVehicleType.ALL_EFFECT,
  },
  {
    label: EffectVehicleTypeText.get(EffectVehicleType.PART_EFFECT),
    value: EffectVehicleType.PART_EFFECT,
  },
  {
    label: EffectVehicleTypeText.get(EffectVehicleType.PART_UN_EFFECT),
    value: EffectVehicleType.PART_UN_EFFECT,
  },
];

/** 生效车范围选项（封路障碍物专用） */
export const effectiveMapOptions = [
  {
    label: EffectiveMapTypeText.get(EffectiveMapType.LD_EFFECTIVE),
    value: EffectiveMapType.LD_EFFECTIVE,
  },
  {
    label: EffectiveMapTypeText.get(EffectiveMapType.HD_EFFECTIVE),
    value: EffectiveMapType.HD_EFFECTIVE,
  },
];

export const searchDynamicMapConfig: FormConfig = {
  fields: [
    {
      fieldName: 'typeList',
      label: '类型',
      type: 'select',
      placeholder: '请选择',
      multiple: true,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      clstag: clstagStr(CLSTAG.SearchParam_TypeList),
      options: [
        {
          label: (
            <div clstag={clstagStr(CLSTAG[AnchorLayerType.MOVE_ROUND])}>
              {AnchorLayerText.get(AnchorLayerType.MOVE_ROUND)}
            </div>
          ),
          value: AnchorLayerType.MOVE_ROUND,
        },
        {
          label: (
            <div clstag={clstagStr(CLSTAG[AnchorLayerType.ROAD_CLOSED])}>
              {AnchorLayerText.get(AnchorLayerType.ROAD_CLOSED)}
            </div>
          ),
          value: AnchorLayerType.ROAD_CLOSED,
        },
        {
          label: (
            <div clstag={clstagStr(CLSTAG[AnchorLayerType.NO_PARKING])}>
              {AnchorLayerText.get(AnchorLayerType.NO_PARKING)}
            </div>
          ),
          value: AnchorLayerType.NO_PARKING,
        },
        {
          label: (
            <div clstag={clstagStr(CLSTAG[AnchorLayerType.FOCUS_AREAS])}>
              {AnchorLayerText.get(AnchorLayerType.FOCUS_AREAS)}
            </div>
          ),
          value: AnchorLayerType.FOCUS_AREAS,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.ATTRIBUTE_ANNOTATION),
          value: AnchorLayerType.ATTRIBUTE_ANNOTATION,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.SPEED_LIMIT),
          value: AnchorLayerType.SPEED_LIMIT,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.AIR_GROUND_GEOFENCE),
          value: AnchorLayerType.AIR_GROUND_GEOFENCE,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.ROAD_TEST_FOCUS_AREA),
          value: AnchorLayerType.ROAD_TEST_FOCUS_AREA,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.LD_ASSIST),
          value: AnchorLayerType.LD_ASSIST,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.NAVIGATION),
          value: AnchorLayerType.NAVIGATION,
        },
        {
          label: AnchorLayerText.get(AnchorLayerType.NO_HORN_ZONE),
          value: AnchorLayerType.NO_HORN_ZONE,
        },
      ],
    },
    {
      fieldName: 'operator',
      label: '操作人',
      type: 'input',
      placeholder: '请选择',
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      clstag: clstagStr(CLSTAG.SearchParam_Operator),
    },
    {
      fieldName: 'status',
      label: '状态',
      type: 'select',
      multiple: true,
      placeholder: '请选择',
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      clstag: clstagStr(CLSTAG.SearchParam_Status),
      options: [
        {
          label: (
            <div clstag={clstagStr(CLSTAG[EffectState.DISABLED])}>
              {EffectStateText.get(EffectState.DISABLED)}
            </div>
          ),
          value: EffectState.DISABLED,
        },
        {
          label: (
            <div clstag={clstagStr(CLSTAG[EffectState.ENABLE])}>
              {EffectStateText.get(EffectState.ENABLE)}
            </div>
          ),
          value: EffectState.ENABLE,
        },
      ],
    },
    {
      fieldName: 'effectDateType',
      label: '生效类别',
      type: 'select',
      multiple: true,
      placeholder: '请选择',
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      clstag: clstagStr(CLSTAG.SearchParam_EffectDateType),
      options: [
        {
          label: (
            <div clstag={clstagStr(CLSTAG[EffectDateType.PERMANENT])}>
              {EffectDateTypeText.get(EffectDateType.PERMANENT)}
            </div>
          ),
          value: EffectDateType.PERMANENT,
        },
        {
          label: (
            <div clstag={clstagStr(CLSTAG[EffectDateType.SEASONAL])}>
              {EffectDateTypeText.get(EffectDateType.SEASONAL)}
            </div>
          ),
          value: EffectDateType.SEASONAL,
        },
      ],
    },
    {
      fieldName: 'remark',
      label: '备注',
      type: 'input',
      placeholder: '请输入（支持模糊搜索）',
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      clstag: clstagStr(CLSTAG.SearchParam_Remark),
    },
    {
      fieldName: 'effectVehicleType',
      label: '生效范围',
      type: 'select',
      placeholder: '请选择',
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      multiple: true,
      clstag: clstagStr(CLSTAG.SearchParam_EffectVehicleType),
      options: EffectVehicleTypeOptions,
    },
  ],
};

export const selectOptions = [
  { value: PositionSelectType.station, label: '站点' },
  { value: PositionSelectType.position, label: '地理位置' },
  { value: PositionSelectType.stop, label: '停靠点' },
  { value: PositionSelectType.vehicle, label: '车号' },
  { value: PositionSelectType.latLag, label: '经纬度' },
];

export interface SearchFormType {
  searchType: string | null;
  value: string | null;
  stopValue: string | null;
  vehicleValue: string | null;
  latitude: any | null;
  longitude: any | null;
  latlngForm: any | null;
}

export const MapStatus = {
  RS_INUSE: 'RS_INUSE',
  RS_DISCARDED: 'RS_DISCARDED',
};
export const variableListMock = [
  {
    id: 1,
    type: 'VOT_TNTA/VOT_ROAD_CLOSURE',
    durationType: 'DT_ERVERLASTING',
    effectDateType: 'LONG_TERM',
    operator: '',
  },
];

export const tileLayer = [
  {
    layerId: LayerIdEnum.INTER_LAYER,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_intersection`,
      STYLES: 'intersection',
    },
  },
  {
    layerId: LayerIdEnum.WSM_LAYER,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_lane`,
      STYLES: 'line-center',
    },
  },
  {
    layerId: LayerIdEnum.OPENAREA_LAYER,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_free_area`,
      STYLES: 'open-area',
    },
  },
  {
    layerId: LayerIdEnum.BOUNDARY_LAYER,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_boundary`,
      STYLES: 'line-boundary',
    },
  },
  {
    layerId: LayerIdEnum.STOPLINE_LAYER,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_stop_line`,
      STYLES: 'line-red',
    },
  },
  {
    layerId: LayerIdEnum.GATE_LAYER,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_gate`,
      STYLES: 'line-gate',
    },
  },
];

export const proxyTileLayer = [
  {
    layerId: LayerIdEnum.INTER_LAYER,
    url: `/api/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_intersection`,
      STYLES: 'intersection',
    },
  },
  {
    layerId: LayerIdEnum.WSM_LAYER,
    url: `/api/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_lane`,
      STYLES: 'line-center',
    },
  },
  {
    layerId: LayerIdEnum.OPENAREA_LAYER,
    url: `/api/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_free_area`,
      STYLES: 'open-area',
    },
  },
  {
    layerId: LayerIdEnum.BOUNDARY_LAYER,
    url: `/api/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_boundary`,
      STYLES: 'line-boundary',
    },
  },
  {
    layerId: LayerIdEnum.STOPLINE_LAYER,
    url: `/api/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_stop_line`,
      STYLES: 'line-red',
    },
  },
  {
    layerId: LayerIdEnum.GATE_LAYER,
    url: `/api/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_gate`,
      STYLES: 'line-gate',
    },
  },
];

export const baiduTileLayer = [
  {
    layerId: LayerIdEnum.INTER_LAYER,
    url: '/api/geoserver/bd09/wms',
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: 'bd09:map_intersection_bd09',
      STYLES: 'intersection',
    },
  },
  {
    layerId: LayerIdEnum.WSM_LAYER,
    url: '/api/geoserver/bd09/wms',
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: 'bd09:map_lane_bd09',
      STYLES: 'line-center',
    },
  },
  {
    layerId: LayerIdEnum.OPENAREA_LAYER,
    url: '/api/geoserver/bd09/wms',
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: 'bd09:map_free_area_bd09',
      STYLES: 'open-area',
    },
  },
  {
    layerId: LayerIdEnum.BOUNDARY_LAYER,
    url: '/api/geoserver/bd09/wms',
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: 'bd09:map_boundary_bd09',
      STYLES: 'line-boundary',
    },
  },
  {
    layerId: LayerIdEnum.STOPLINE_LAYER,
    url: '/api/geoserver/bd09/wms',
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: 'bd09:map_stop_line_bd09',
      STYLES: 'line-red',
    },
  },
  {
    layerId: LayerIdEnum.GATE_LAYER,
    url: '/api/geoserver/bd09/wms',
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: 'bd09:map_gate_bd09',
      STYLES: 'line-gate',
    },
  },
];
